import http from 'hub-http/clients/apiClient';
export function fetchFunctionDefinition(actionTypeId) {
  return http.get(`automation/v4/actions/internal/portal-specific/definitions/functions/hydrated/${actionTypeId}/ON_ACTION_EXECUTION`);
}

// fetch outputs for ALL actions
export function getActionOutputs(flowId) {
  return http.get(`automationplatform/v1/output-fields/flow/${flowId}/allOutputs`);
}